/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'confluence-table-tree.column.contributors': 'Katkıda bulunanlar',
  'confluence-table-tree.column.last-modified': 'Son değişiklik',
  'confluence-table-tree.column.title': 'Adı',
  'confluence-table-tree.could-not-load': 'Yüklenemedi',
  'confluence-table-tree.could-not-load-contributors': 'Katkıda bulunanlar yüklenemedi',
  'confluence-table-tree.create-child-page': 'Alt sayfa oluştur',
  'confluence-table-tree.create-page': 'Sayfa oluştur',
  'confluence-table-tree.default.page.title': 'Başlıksız',
  'confluence-table-tree.default.show-all-pages-button.label': 'Daha fazla sayfa göster',
  'confluence-table-tree.draft.lozenge': 'TASLAK',
  'confluence-table-tree.draft.tooltip': 'Taslaklar yalnızca sizin tarafınızdan görülebilir.',
  'confluence-table-tree.drafts-toggle.label': 'Taslakları göster',
  'confluence-table-tree.edit': 'Düzenle',
  'confluence-table-tree.edit-in-confluence': "Confluence'ta düzenleyin",
  'confluence-table-tree.empty.description':
    'Bu alanı doldurmak için toplantı notları, ürün gereklilikleri, kararlar veya başka içerikler oluşturun.',
  'confluence-table-tree.empty.title': 'Bu sayfada henüz içerik yok',
  'confluence-table-tree.error.description': 'Size bu sayfaları gösteremiyoruz. Lütfen daha sonra yeniden deneyin.',
  'confluence-table-tree.error.row': 'Sayfalar yüklenemedi.',
  'confluence-table-tree.error.title': 'Bir sorun var...',
  'confluence-table-tree.friendly-when-created': 'Oluşturulma',
  'confluence-table-tree.friendly-when-updated': 'Güncellenme',
  'confluence-table-tree.share.copied': 'Panoya kopyalandı',
  'confluence-table-tree.share.copy-button': 'Kopyala',
  'confluence-table-tree.share.subtitle': 'Bu bağlantıyı paylaşın',
  'confluence-table-tree.share.title': 'Sayfayı paylaşın',
  'confluence-table-tree.share.tooltip': 'Paylaş',
  'confluence-table-tree.view-profile': 'Profili görüntüle',
};
